import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TermsOfServiceToMembershipUpdateEdge } from '@app/registration/graph/edges/terms-of-service-to-membership-update.edge';
import { TermsOfServiceToMfaEdge } from '@app/registration/graph/edges/terms-of-service-to-mfa.edge';
import { NodeUrlMappingService } from '@app/registration/graph/node-url-mapping.service';
import { RegistrationNode } from '@app/registration/graph/nodes/registration.node';

@Injectable({
  providedIn: 'root',
})
export class TermsOfServiceNode extends RegistrationNode {
  constructor(
    private termsOfServiceToMfaEdge: TermsOfServiceToMfaEdge,
    private termsOfServiceToMembershipUpdateEdge: TermsOfServiceToMembershipUpdateEdge,
    nodeUrlMappingService: NodeUrlMappingService,
    router: Router,
  ) {
    super(nodeUrlMappingService, router);
    this.edges = [termsOfServiceToMfaEdge, termsOfServiceToMembershipUpdateEdge];
  }
}
